import React, { Dispatch, SetStateAction, useEffect } from 'react';
import { dateFormat, format12Hour, singleDigit12HourFormat, tempTimeOptions } from '../../../constants/constants';
import moment from 'moment';
import styles from './CustomUnitAvailability.module.css';


interface SelectedUnitAvailabilityProps {
    selectedDate: Date;
    setSelectedSlots: Dispatch<SetStateAction<number[]>>;
    selectedSlots: number[];
}

const CustomUnitAvailability = ({
    selectedDate,
    selectedSlots,
    setSelectedSlots,
}: SelectedUnitAvailabilityProps) => {
    // const selectSlotHandler = (index: number) => {
    //     const timeFormat = 'HH:mm';
    //     const data = tempTimeOptions;

    //     if (selectedSlots.includes(index)) {
    //         const newSelectedSlots = selectedSlots.filter(slot => slot !== index);

    //         const contiguousRanges: number[][] = [];
    //         let currentRange: number[] = [];

    //         for (let i = 0; i < newSelectedSlots.length; i++) {
    //             if (
    //                 currentRange.length === 0 ||
    //                 newSelectedSlots[i] === currentRange[currentRange.length - 1] + 1
    //             ) {
    //                 currentRange.push(newSelectedSlots[i]);
    //             } else {
    //                 contiguousRanges.push(currentRange);
    //                 currentRange = [newSelectedSlots[i]];
    //             }
    //         }

    //         if (currentRange.length > 0) {
    //             contiguousRanges.push(currentRange);
    //         }
    //         const longestRange = contiguousRanges.reduce((a, b) => (a.length > b.length ? a : b), []);
    //         setSelectedSlots(longestRange);
    //     } else {

    //         if (selectedSlots.length === 0) {
    //             setSelectedSlots([index]);
    //         } else {
    //             const lastSelectedSlot = selectedSlots[selectedSlots.length - 1];

    //             if (
    //                 index === lastSelectedSlot + 1 &&
    //                 data[index].value === moment(`${data[lastSelectedSlot].value}`, timeFormat).add(1, 'hours').format(timeFormat)
    //             ) {
    //                 setSelectedSlots([...selectedSlots, index]);
    //             } else if (
    //                 index === selectedSlots[0] - 1 &&
    //                 data[selectedSlots[0]].value === moment(`${data[index].value}`, timeFormat).add(1, 'hours').format(timeFormat)
    //             ) {
    //                 setSelectedSlots([index, ...selectedSlots]);
    //             } else {
    //                 setSelectedSlots([index]);
    //             }
    //         }
    //     }
    // };

    const selectSlotHandler = (index: number) => {
        // const data = tempTimeOptions;

        let newSelectedSlots: number[];
        if (selectedSlots.includes(index)) {
            // Remove the slot if it's already selected
            newSelectedSlots = selectedSlots.filter(slot => slot !== index);
        } else {
            // Add the new slot
            newSelectedSlots = [...selectedSlots, index];
        }

        // Sort the selected slots
        newSelectedSlots.sort((a, b) => a - b);

        setSelectedSlots(newSelectedSlots);
    };

    useEffect(() => {
        let slotRange = '';
        const data = tempTimeOptions;

        const firstSlot = data[selectedSlots[0]];
        const lastSlot = data[selectedSlots[selectedSlots.length - 1]];

        if (firstSlot && lastSlot) {
            const startTime = moment(firstSlot.value, format12Hour).format(singleDigit12HourFormat);
            const endTime = moment(lastSlot.value, format12Hour).add(1, 'hours').format(singleDigit12HourFormat);
            slotRange = `${startTime} - ${endTime}`;
        }
    }, [selectedSlots]);

    return (
        <div className={styles.unitName}>

            <div className={styles.slotsListing}>
                {tempTimeOptions.slice(0, -1).map((hours: { label: string }, index: number) => {
                    const isSelected = selectedSlots.includes(index);

                    const currentHour = moment().format('HH:mm');

                    const startTime = moment(hours.label, 'HH:mm').startOf('hour');
                    const todaysDate = moment().format('YYYY-MM-DD');

                    if (
                        moment(selectedDate).format(dateFormat) === todaysDate &&
                        startTime.add(1, 'hour').isSameOrAfter(moment(currentHour, 'HH:mm'))
                    ) {
                        return (
                            <div
                                onClick={() => selectSlotHandler(index)}
                                className={isSelected ? styles.selected : styles.fullDaySlotItem}
                                key={index}>
                                <span key={index}>{moment(hours.label, 'HH:mm').format('h A')} - </span>{' '}
                                <span>&nbsp;{moment(hours.label, 'HH:mm').add(1, 'hours').format('h A')}</span>
                            </div>
                        );
                    } else if (moment(selectedDate).format(dateFormat) !== todaysDate) {
                        return (
                            <div
                                onClick={() => selectSlotHandler(index)}
                                className={isSelected ? styles.selected : styles.fullDaySlotItem}
                                key={index}>
                                <span key={index}>{moment(hours.label, 'HH:mm').format('h A')}&nbsp;</span>
                                <span>{`-`}</span>
                                <span>&nbsp;{moment(hours.label, 'HH:mm').add(1, 'hours').format('h A')}</span>
                            </div>
                        );
                    }
                })}
            </div>
        </div>
    );
};

export default CustomUnitAvailability;
